import { useQuery, UseQueryResult } from 'react-query';
import { SearchSuggestItem } from '../../models/SearchSuggest';
import { fetchSearchSuggest } from '../../services/searchSuggest/searchSuggest.service';
import { queryKeys } from '../queryKeyFactory';
import { getTrimmedSearchTerm } from '../../utils/searchSuggestUtils';

export default (term: string): UseQueryResult<SearchSuggestItem[], Error> => {
  return useQuery<SearchSuggestItem[], Error>(queryKeys.searchSuggest.allByTerm(term), async () => {
    if (term.length === 0) {
      return [];
    }

    const trimmedTerm = getTrimmedSearchTerm(term);
    return fetchSearchSuggest(trimmedTerm);
  });
};
